import { useEffect, useState } from "react";
import Icon from "@mdi/react";
import { mdiChevronDown, mdiPlus } from "@mdi/js";
import { Link } from "easy-page-router/react";
import { useLang, dictionary } from "../../../services/lang";
import { api, handleError } from "../../../services/api";
import { useUser } from "../../../components/User";
import { ThemeDiv } from "../../../components/Theme";
import { AccordionContent, Loading } from "../../../components";
import { TeamPreview, Lang, ID } from "../../../../types";

export function getTeamUrl(lang: Lang, teamId: ID) {
    const dict = dictionary[lang];
    return `/${dict.urlTeam}/${teamId}`;
}

export function TeamSelect({ team, onTeamEdit }: { team: TeamPreview, onTeamEdit: (team: TeamPreview) => void }) {
    const { lang, dict } = useLang();
    const { userId } = useUser();

    const [teams, setTeams] = useState<TeamPreview[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<null | string>(null);

    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (open) {
            setIsLoading(true);
            api.getTeamPreviews({ userId }).then(([teams, error]) => {
                if (error) {
                    handleError(error);
                    setError(error);
                } else if (teams) {
                    setTeams(teams);
                }
                setIsLoading(false);
            });
        }
    }, [open, userId]);

    function onNewTeam() {
        onTeamEdit({
            _id: "",
            lang,
            title: "",
            description: "",
            theme: "",
        });
    }

    return <>
        <div className={`team-select block width-max ${open ? "open" : ""}`} onClick={() => setOpen(!open)}>
            <label>{dict.teamName}</label>
            <Icon path={mdiChevronDown} size={2} />
            <h1 className="line-clamp-1">{team.title}</h1>

            <AccordionContent open={open}>
                {isLoading && <Loading />}
                {error && <p className="error">{dict.teamError}</p>}
                <div className="team-list">
                    {teams && teams.map(({ _id, lang, title, description, theme }) => <Link key={_id} href={getTeamUrl(lang, _id)}>
                        <ThemeDiv theme={theme} className={team._id === _id ? "active" : ""}>
                            <h3 className="line-clamp-2">{title}</h3>
                            <p className="pre-line line-clamp-3">{description}</p>
                        </ThemeDiv>
                    </Link>)}
                    <a className="button-new" onClick={onNewTeam}>
                        <Icon path={mdiPlus} size={1} /> {dict.teamCreate}
                    </a>
                </div>
            </AccordionContent>
        </div>
    </>;
}
